function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#596266",
  d: "M13.1398904,7.80468543 L15,9.66479501 L13.664795,11 L11.8046854,9.13989042 C11.5520226,9.31139787 11.2828323,9.46038162 11,9.58395631 L11,15 C11,15.5522847 10.5522847,16 10,16 L2,16 C1.44771525,16 1,15.5522847 1,15 L1,3 C1,2.44771525 1.44771525,2 2,2 L4.99963381,2 C5.91184014,0.785553298 7.36418217,0 9,0 C11.7614237,0 14,2.23857625 14,5 C14,6.03948962 13.6827906,7.004891 13.1398904,7.80468543 Z M9,10 C6.23857625,10 4,7.76142375 4,5 C4,4.65753416 4.03443026,4.32310994 4.10001812,4 L3,4 L3,14 L9,14 L9,10 Z M9,8 C10.6568542,8 12,6.65685425 12,5 C12,3.34314575 10.6568542,2 9,2 C7.34314575,2 6,3.34314575 6,5 C6,6.65685425 7.34314575,8 9,8 Z"
});

var SvgPreview = function SvgPreview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Preview.4f5999d5.svg";
export { ForwardRef as ReactComponent };